<template>
    <div class="safe_alarm_pop" v-if="typeof safetyInfo.registerNo !== 'undefined'">
        <div class="top_title">알림 메세지</div>
        <div class="alarm_list">
            <div class="tit">
                <span class="t_red">[{{ safetyInfo.safetyCategory }}]</span>
                {{ safetyInfo.safetyType }}
            </div>
            <div class="alarm_tbl">
                <table>
                    <caption>재난리스트</caption>
                    <colgroup>
                        <col style="width:25%;">
                        <col style="width:75%;">
                    </colgroup>
                    <tbody>
                    <tr>
                        <th><i></i>발생일시</th>
                        <td><span>{{ safetyInfo.registerTime | formatDate('yyyy.MM.dd HH:mm') }}</span></td>
                    </tr>
                    <tr>
                        <th><i></i>현재상황</th>
                        <td><span class="t_orange">{{ curState }} {{ recDateHm }}</span></td>
                    </tr>
                    <tr>
                        <th><i></i>발생위치</th>
                        <td><span>{{ safetyInfo.address }}</span></td>
                    </tr>
                    <tr>
                        <th><i></i>처리기관</th>
                        <td><span>{{ safetyInfo.controlStation }}</span></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <a href="#" @click.prevent="closeSafetyAlarm()" class="alarm_btn_close">닫기</a>
        <a href="#" @click.prevent="closeSafetyAlarm()" class="alarm_btn_close2">닫기</a>
    </div>

</template>

<script>

import realtimeApi from "@/apis/realtime.api";
import { $_WC } from "@/confs/common.const.js";

export default {
    data() {
        return {
            safetyInfo: {},
            historyMap: {},
            curState: '',
            curStateCd: -1,
            recDateHm: '',
            isTransfer: false,
        };
    },
    created() {
        let time = 1000 * 60 * 1;


        // TODO 제거 - start: 로컬테스트
        if(process.env.NODE_ENV === 'local'){
            time = 1000 * 15;
        }
        // TODO 제거 - end: 로컬테스트


        this.getSafetyInfo();
        setInterval(()=>{
            this.getSafetyInfo();
        }, time);
    },
    methods: {
        getSafetyInfo(){
            let now = new Date();
            let nowStr = now.format('yyyyMMdd');
            let q = 'stateMode=1&intervalDay=1&searchFromDate=' + nowStr + '000000&searchToDate=' + nowStr + '235959';


            // TODO 제거 - start: 로컬테스트
            if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
                q = 'stateMode=1&intervalDay=1200&searchFromDate=20200830000000&searchToDate=20220830235959';
            }
            // TODO 제거 - end: 로컬테스트


            realtimeApi.fetchSafetyList(q).then(res => {
                if(res.data.data.length > 0){
                    let safetyList = res.data.data.filter(d => {
                        // 재난/화재 표출
                        // return d.safetyCategoryCd === '0' || d.safetyCategoryCd === '1' && !!d.wtmX && !!d.wtmY;
                        if(d.safetyCategoryCd === '0') {
                            // 재난의 경우 일괄 표출
                            return true;
                        } else if(d.safetyCategoryCd === '1' && d.safetyTypeCd === '11D') {
                            // 화재의 경우 대형화재취약 이거나 중점관리대상인 항목만
                            return true;
                        } else {
                            return false;
                        }
                    });
                    if(safetyList.length > 1){
                        safetyList.sort((p, c) => {
                            return Number(c.registerTime) - Number(p.registerTime);
                        });
                    }


                    // TODO 제거 - start: 로컬테스트
                    // if(process.env.NODE_ENV === 'local') {
                    //     safetyList = res.data.data;
                    //     if(safetyList.length > 1){
                    //         safetyList.sort((p, c) => {
                    //             return Math.random() - 0.5;
                    //         });
                    //     }
                    // }
                    // TODO 제거 - end: 로컬테스트


                    if(safetyList.length > 0){
                        this.setSafetyAlarmData(safetyList[0]);
                    }
                }
            });
        },
        setSafetyAlarmData(safety){
            // 라이브한 데이터만 호출
            let storageData = this.getSafetyStorage();
            // 스토리지가 비어있는 경우 초기 설정
            if(storageData === null) {
                let empty = {registerNo: ''};
                this.setSafetyStorage(empty);
                storageData = this.getSafetyStorage();
            }

            if (safety.registerNo !== storageData.registerNo) {
                this.closeSafetyAlarm();
                realtimeApi.fetchSafety(safety.registerNo).then(res => {

                    let historyList = res.data.data.safetyHistoryList;
                    let historyMap = {};
                    let lastHistory = {};

                    if(typeof historyList !== 'undefined') {
                        for(let i = 0; i < historyList.length; i++) {
                            let historyStatuCd = historyList[i]['processStateCd'];
                            historyMap['S_' + historyStatuCd] = historyList[i];

                            if(historyList[i].processState === '이송중') {
                                this.isTransfer = true;
                            }

                            if(i === (historyList.length - 1)) {
                                lastHistory = historyList[i];
                            }
                        }
                    }
                    // console.log( historyList, historyMap, lastHistory );
                    this.historyMap = historyMap;
                    this.curState = '' || lastHistory['processState'];
                    this.curStateCd = '' || lastHistory['processStateCd'];
                    this.safetyInfo = safety;

                    if(!!this.historyMap['S_' + this.curStateCd] && !!this.historyMap['S_' + this.curStateCd].recDateHm){
                        this.recDateHm = '(' + this.historyMap['S_' + this.curStateCd].recDateHm + ')';
                    }
                    this.soundPaly();

                    this.setSafetyStorage(safety);
                    this.$eventBus.$emit("event-click");  // 롤링 시간 초기화
                });
            }
        },
        soundPaly(){
            let sound = $_WC.assets + 'img/alert1.mp3';
            let audio = new Audio(sound);
            audio.play();
        },
        getTimestamp(){
            return new Date().getTime();
        },
        setSafetyStorage(safety) {
            localStorage.setItem('safetyAlarmData', JSON.stringify(safety));
        },
        getSafetyStorage() {
            return JSON.parse(localStorage.getItem('safetyAlarmData'));
        },
        closeSafetyAlarm(){
            this.safetyInfo = {};
            this.historyMap = {};
            this.curState = '';
            this.curStateCd = -1;
            this.recDateHm = '';
            this.isTransfer = false;
        },
    },
};
</script>
<style>
.popup_wrap .time_line .time.real{position: absolute; bottom:95%; left: 15%;}
.simple_popup_wrap .time_line .time.real{position: absolute; bottom:95%; left: 15%;}
</style>
